module.exports = __webpack_public_path__ + "static/media/2.329e1f0f.svg";